export interface PaginationConfig {
  paginationEnabled: boolean;
  startIndex: number;
  pageSize: number;
}
